<!-- Buy Words Modal -->
<div *ngIf="isOpen" class="modal-overlay" (click)="onOverlayClick($event)">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header-fixed">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="modal-title">{{ translations.buyWordsTitle }}</h2>
          <span *ngIf="currentUserEmail" class="text-sm text-gray-600 font-normal">
            ({{ currentUserEmail }})
          </span>
        </div>
        <p class="modal-subtitle">{{ translations.buyWordsSubtitle }}</p>
      </div>
      <button (click)="onClose()" class="close-button">
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-body">
      <!-- Package Selection View -->
      <div *ngIf="!showPaymentForm">
        <!-- Word Packages Section -->
        <div class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 mb-4">
            {{ translations.selectWordPackage || 'Word Packages' }}
          </h3>
          <p class="text-sm text-gray-600 mb-4">
            {{ translations.oneTimePurchase }} -
            {{ translations.buyMoreSaveMore }}
          </p>

          <!-- Word Package List -->
          <div class="mb-6">
            <div class="grid grid-cols-1 gap-3">
              <label
                *ngFor="let pkg of wordPackages"
                class="relative flex items-center p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-blue-300 hover:bg-blue-50 transition-colors"
                [class.border-blue-500]="selectedWordPackage?.id === pkg.id"
                [class.bg-blue-50]="selectedWordPackage?.id === pkg.id"
                (click)="onWordPackageSelect(pkg.id)"
              >
                <input
                  type="checkbox"
                  name="wordPackage"
                  [value]="pkg.id"
                  [checked]="selectedWordPackage?.id === pkg.id"
                  class="sr-only"
                />
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center">
                    <div
                      class="w-4 h-4 border-2 rounded mr-3 transition-colors"
                      [class.border-blue-500]="selectedWordPackage?.id === pkg.id"
                      [class.bg-blue-500]="selectedWordPackage?.id === pkg.id"
                      [class.border-gray-300]="selectedWordPackage?.id !== pkg.id"
                    >
                      <div
                        *ngIf="selectedWordPackage?.id === pkg.id"
                        class="w-2 h-2 bg-white rounded-sm m-0.5"
                      ></div>
                    </div>
                    <div>
                      <div class="flex items-center gap-2">
                        <span class="font-medium text-gray-900">{{
                          pkg.name
                        }}</span>
                      </div>
                      <div class="text-sm text-gray-500">
                        {{ pkg.words.toLocaleString() }} {{ translations.data || 'words' }}
                        <span *ngIf="pkg.description">
                          • {{ pkg.description }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="text-right">
                    <div class="font-semibold text-blue-600">
                      {{ formatPrice(pkg.price || 0) }}
                    </div>
                    <div
                      *ngIf="pkg.originalPrice"
                      class="text-xs text-gray-400 line-through"
                    >
                      {{ formatPrice(pkg.originalPrice) }}
                    </div>
                    <div
                      *ngIf="pkg.savings"
                      class="text-xs text-green-600 font-medium"
                    >
                      {{ translations.save }} {{ pkg.savings }}%
                    </div>
                    <div
                      *ngIf="!pkg.originalPrice && !pkg.savings"
                      class="text-xs text-gray-500"
                    >
                      {{ translations.oneTimePurchase }}
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <!-- Image Packages Section -->
        <div class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 mb-4">
            Image Packages
          </h3>
          <p class="text-sm text-gray-600 mb-4">
            {{ translations.oneTimePurchase }} -
            {{ translations.buyMoreSaveMore }}
          </p>

          <!-- Image Package List -->
          <div class="mb-6">
            <div class="grid grid-cols-1 gap-3">
              <label
                *ngFor="let pkg of imagePackages"
                class="relative flex items-center p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-green-300 hover:bg-green-50 transition-colors"
                [class.border-green-500]="selectedImagePackage?.id === pkg.id"
                [class.bg-green-50]="selectedImagePackage?.id === pkg.id"
                (click)="onImagePackageSelect(pkg.id)"
              >
                <input
                  type="checkbox"
                  name="imagePackage"
                  [value]="pkg.id"
                  [checked]="selectedImagePackage?.id === pkg.id"
                  class="sr-only"
                />
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center">
                    <div
                      class="w-4 h-4 border-2 rounded mr-3 transition-colors"
                      [class.border-green-500]="selectedImagePackage?.id === pkg.id"
                      [class.bg-green-500]="selectedImagePackage?.id === pkg.id"
                      [class.border-gray-300]="selectedImagePackage?.id !== pkg.id"
                    >
                      <div
                        *ngIf="selectedImagePackage?.id === pkg.id"
                        class="w-2 h-2 bg-white rounded-sm m-0.5"
                      ></div>
                    </div>
                    <div>
                      <div class="flex items-center gap-2">
                        <span class="font-medium text-gray-900">{{
                          pkg.name
                        }}</span>
                      </div>
                      <div class="text-sm text-gray-500">
                        {{ pkg.images.toLocaleString() }} images
                        <span *ngIf="pkg.description">
                          • {{ pkg.description }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="text-right">
                    <div class="font-semibold text-green-600">
                      {{ formatPrice(pkg.price || 0) }}
                    </div>
                    <div
                      *ngIf="pkg.originalPrice"
                      class="text-xs text-gray-400 line-through"
                    >
                      {{ formatPrice(pkg.originalPrice) }}
                    </div>
                    <div
                      *ngIf="pkg.savings"
                      class="text-xs text-green-600 font-medium"
                    >
                      {{ translations.save }} {{ pkg.savings }}%
                    </div>
                    <div
                      *ngIf="!pkg.originalPrice && !pkg.savings"
                      class="text-xs text-gray-500"
                    >
                      {{ translations.oneTimePurchase }}
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <!-- Selected Packages Summary -->
        <div
          *ngIf="hasSelection()"
          class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg"
        >
          <h4 class="font-medium text-blue-900 mb-2">Selected Packages</h4>
          <div class="space-y-2">
            <div *ngIf="selectedWordPackage" class="flex justify-between items-center">
              <div>
                <div class="font-semibold text-blue-800">
                  {{ selectedWordPackage.name }}
                </div>
                <div class="text-sm text-blue-600">
                  {{ selectedWordPackage.words.toLocaleString() }} words
                </div>
              </div>
              <div class="text-right font-bold text-blue-700">
                {{ formatPrice(selectedWordPackage.price || 0) }}
              </div>
            </div>
            <div *ngIf="selectedImagePackage" class="flex justify-between items-center">
              <div>
                <div class="font-semibold text-green-800">
                  {{ selectedImagePackage.name }}
                </div>
                <div class="text-sm text-green-600">
                  {{ selectedImagePackage.images.toLocaleString() }} images
                </div>
              </div>
              <div class="text-right font-bold text-green-700">
                {{ formatPrice(selectedImagePackage.price || 0) }}
              </div>
            </div>
            <div class="pt-2 border-t border-blue-300 flex justify-between items-center">
              <div class="font-bold text-blue-900">Total</div>
              <div class="text-right font-bold text-blue-700 text-lg">
                {{ formatPrice(getTotalPrice()) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Purchase Button -->
        <div class="flex justify-center pt-4">
          <button
            (click)="onAddWords()"
            [disabled]="!hasSelection() || isProcessingPayment"
            class="min-w-[240px] px-8 py-4 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
          >
            <div
              *ngIf="isProcessingPayment"
              class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin flex-shrink-0"
            ></div>
            <span class="text-sm text-center whitespace-nowrap px-2">
              {{ getButtonText() }}
            </span>
          </button>
        </div>

        <!-- Admin Info Note -->
        <div
          *ngIf="isAdmin()"
          class="mt-6 p-3 bg-purple-50 border border-purple-200 rounded-lg"
        >
          <div class="flex items-start">
            <svg
              class="w-5 h-5 text-purple-500 mr-2 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              ></path>
            </svg>
            <div class="text-sm text-purple-700">
              <div class="font-medium mb-1">👑 Admin Access</div>
              <p>
                As an admin, you can add words to your account for free without
                payment processing.
              </p>
            </div>
          </div>
        </div>

        <!-- Info Note -->
        <div class="mt-6 p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <div class="flex items-start">
            <svg
              class="w-5 h-5 text-gray-500 mr-2 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <div class="text-sm text-gray-600">
              <div class="font-medium mb-1">{{ translations.howItWorks }}</div>
              <ul class="list-disc list-inside space-y-1">
                <li>
                  {{ translations.oneTimePurchaseAddsWords }}
                </li>
                <li>{{ translations.wordsConsumedAsYouUse }}</li>
                <li>{{ translations.noExpirationUseWords }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Form View -->
      <div *ngIf="showPaymentForm">
        <!-- Back Button -->
        <div class="mb-4">
          <button
            (click)="onBackToPackages()"
            class="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
          >
            <svg
              class="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Back to packages
          </button>
        </div>


        <!-- Payment Error -->
        <div
          *ngIf="paymentError"
          class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg"
        >
          <div class="flex items-center">
            <svg
              class="w-5 h-5 text-red-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span class="text-sm text-red-700">{{ paymentError }}</span>
          </div>
        </div>

        <!-- Stripe Payment Element -->
        <div class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 mb-4">
            Payment Information
          </h3>
          <div
            id="payment-element"
            class="p-4 border border-gray-200 rounded-lg bg-white w-full"
            style="min-height: 200px; width: 100%; touch-action: manipulation"
          >
            <!-- Stripe Elements will be mounted here -->
            <div class="text-center text-gray-500 text-sm py-8">
              Loading payment form...
            </div>
          </div>

          <!-- Add CSS to fix Stripe input field sizing -->
          <style>
            #payment-element input {
              width: 100% !important;
              min-width: 200px !important;
              padding: 12px !important;
              font-size: 16px !important;
              border: 1px solid #d1d5db !important;
              border-radius: 8px !important;
            }

            #payment-element .p-Input {
              width: 100% !important;
              min-width: 200px !important;
            }

            #payment-element iframe {
              width: 100% !important;
              min-width: 200px !important;
            }
          </style>
        </div>

        <!-- Payment Button -->
        <div class="flex justify-center pt-4">
          <button
            (click)="onConfirmPayment()"
            [disabled]="isProcessingPayment"
            class="min-w-[240px] px-8 py-4 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
          >
            <div
              *ngIf="isProcessingPayment"
              class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin flex-shrink-0"
            ></div>
            <span class="text-sm text-center whitespace-nowrap px-2">
              {{
                isProcessingPayment
                  ? "Processing Payment..."
                  : "Complete Payment"
              }}
            </span>
          </button>
        </div>

        <!-- Security Note -->
        <div class="mt-6 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div class="flex items-start">
            <svg
              class="w-5 h-5 text-green-500 mr-2 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              ></path>
            </svg>
            <div class="text-sm text-green-700">
              <div class="font-medium mb-1">Secure Payment</div>
              <p>
                Your payment is processed securely by Stripe. We never store
                your payment information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
